// hnb-frontend/src/components/public/PublicFooter.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import HnbLogo from '../brand/HnbLogo';
import { useAuth } from '../../hooks/useAuth';

const footerLinkStyle: React.CSSProperties = {
  textDecoration: 'none',
  color: '#cbd5e1',
  fontSize: '0.95rem',
  lineHeight: 1.5,
};

const footerButtonStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  textDecoration: 'none',
  color: '#cbd5e1',
  fontSize: '0.95rem',
  lineHeight: 1.5,
  cursor: 'pointer',
  textAlign: 'left',
};

const sectionTitleStyle: React.CSSProperties = {
  margin: 0,
  marginBottom: '0.9rem',
  color: '#ffffff',
  fontSize: '1rem',
  fontWeight: 700,
  letterSpacing: '0.01em',
};

export default function PublicFooter() {
  const { user, logout } = useAuth();

  return (
    <footer
      style={{
        marginTop: '4rem',
        background:
          'linear-gradient(180deg, #0f172a 0%, #111827 54%, #0b1220 100%)',
        color: '#e2e8f0',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '3rem 1.25rem 1.5rem',
          display: 'grid',
          gridTemplateColumns:
            'minmax(280px, 1.45fr) repeat(3, minmax(160px, 1fr))',
          gap: '2rem',
          alignItems: 'start',
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              marginBottom: '1rem',
              minWidth: 0,
            }}
          >
            <HnbLogo
              imageHeight={68}
              titleColor="#ffffff"
              subtitleColor="#cbd5e1"
              style={{ borderRadius: 18 }}
            />
          </div>

          <p
            style={{
              marginTop: '0.95rem',
              marginBottom: 0,
              color: '#cbd5e1',
              lineHeight: 1.75,
              fontSize: '0.95rem',
              maxWidth: 360,
            }}
          >
            A Belfast-first platform for AI-supported style discovery, provider
            comparison, and beauty and grooming bookings across distinct public,
            customer, and provider-owner surfaces.
          </p>
        </div>

        <div style={{ minWidth: 0 }}>
          <h4 style={sectionTitleStyle}>Explore</h4>
          <div style={{ display: 'grid', gap: '0.65rem' }}>
            <Link to="/about" style={footerLinkStyle}>
              About
            </Link>
            <Link to="/services" style={footerLinkStyle}>
              Services
            </Link>
            <Link to="/find-provider" style={footerLinkStyle}>
              Find provider
            </Link>
            <Link to="/ai-plans" style={footerLinkStyle}>
              AI plans
            </Link>
            <Link to="/provider-plans" style={footerLinkStyle}>
              Provider plans
            </Link>
          </div>
        </div>

        <div style={{ minWidth: 0 }}>
          <h4 style={sectionTitleStyle}>Company</h4>
          <div style={{ display: 'grid', gap: '0.65rem' }}>
            <Link to="/team" style={footerLinkStyle}>
              Team
            </Link>
            <Link to="/careers" style={footerLinkStyle}>
              Careers
            </Link>
            <Link to="/downloads" style={footerLinkStyle}>
              Downloads
            </Link>
            <Link to="/contact" style={footerLinkStyle}>
              Contact
            </Link>

            {user ? (
              <button type="button" onClick={logout} style={footerButtonStyle}>
                Log out
              </button>
            ) : (
              <Link to="/login" style={footerLinkStyle}>
                Login
              </Link>
            )}
          </div>
        </div>

        <div style={{ minWidth: 0 }}>
          <h4 style={sectionTitleStyle}>Platform</h4>
          <p
            style={{
              margin: 0,
              color: '#cbd5e1',
              lineHeight: 1.75,
              fontSize: '0.95rem',
              maxWidth: 290,
            }}
          >
            Public discovery sits alongside protected provider-owner and later
            staff-facing operational surfaces, while sensitive decisions stay in
            backend policy and data layers.
          </p>
        </div>
      </div>

      <div
        style={{
          borderTop: '1px solid rgba(226, 232, 240, 0.12)',
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: '0 auto',
            padding: '1rem 1.25rem 1.4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1rem',
            flexWrap: 'wrap',
            color: '#94a3b8',
            fontSize: '0.9rem',
          }}
        >
          <span>© 2026 Handsome & Beautiful. All rights reserved.</span>
          <span>Belfast, Northern Ireland</span>
        </div>
      </div>
    </footer>
  );
}